<script>
import { get_currency, get_decimal } from "../../../Helper/helper";
export default {
  props: ["orders", "loading", "extra-columns", "status"],

  data() {
    return {
      filters: {
        order_status: this.order_status,
      },
      meta: [
        { charset: "utf-8" },
        { equiv: "Content-Type", content: "text/html" },
        { name: "viewport", content: "width=device-width, initial-scale=1" },
      ],
      decimal: get_decimal(),
      currency: get_currency(),
      fields: [
        {
          key: "order_id",
          label: this.trans.get("__JSON__.Order ID"),
          sortable: false,
        },
        //{ key: "vendor_name", label: this.trans.get("__JSON__.Vendor's Name1"), sortable: false },
        {
          key: "customer_name",
          label: this.trans.get("__JSON__.Customer Name"),
          sortable: false,
        },
        ...(this.extraColumns || []),
        {
          key: "order_date",
          label: this.trans.get("__JSON__.Time"),
          sortable: false,
        },
        {
          key: "total_amount",
          label: this.trans.get("__JSON__.Amount"),
          sortable: false,
        },
        {
          key: "payment_method",
          label: this.trans.get("__JSON__.Payment Method"),
          sortable: false,
        },
        {
          key: "order_status",
          label: this.trans.get("__JSON__.Order Status"),
          sortable: false,
        },

        // {
        //   key: "action",
        //   label: this.trans.get("__JSON__.Action"),
        //   sortable: false,
        // },
      ],
      showModal: false,
      order: null,
      viewIndex: 0,
      orderId: null,
      abandonedstatus: "",
    };
  },
};
</script>
<template>
  <div class="row">
    <div class="col-12 m-order-main">
      <div class="order-table-data table-responsive order-data-table">
        <b-table
          :items="(orders && orders.data) || []"
          :fields="fields"
          ref="selectableTable"
          show-empty
          :busy="loading"
          class="
            table-centered table-nowrap table-hover table-main-border
            order-menu
          "
          selectable
          select-mode="single"
        >
          <!-- @row-clicked="viewPageDetails" -->
          <template #empty>
            <p class="text-center">
              {{ trans.get("__JSON__.No Order Found") }}
            </p>
          </template>
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>{{ trans.get("__JSON__.Loading...") }}</strong>
            </div>
          </template>
          <template #cell(order_id)="data">
            <span class="font-weight-bold">{{ "#" + data.value }}</span>
            <span
              class="badge badge-pill badge-soft-primary font-size-12"
              v-if="data.item.delivery_type == '1'"
            >
              {{ trans.get("__JSON__.Delivery") }}
            </span>
            <span
              class="badge badge-pill badge-soft-danger font-size-12"
              v-if="data.item.delivery_type == '0'"
            >
              {{ trans.get("__JSON__.Pickup") }}
            </span>
            <br
              v-if="
                data.item.future_delivery_date != '0000-00-00 00:00:00' &&
                data.item.future_delivery_date != null
              "
            />
            <span
              class="badge badge-pill badge-success font-size-12"
              v-if="
                data.item.future_delivery_date != '0000-00-00 00:00:00' &&
                data.item.future_delivery_date != null
              "
            >
              Scheduled
            </span>
          </template>

          <template #cell(customer_name)="data">
            {{ data.value }}
          </template>

          <template #cell(order_date)="data">
            <span v-if="data.item.status_name == 'Placed'"
              >{{ moment(data.item.order_date).fromNow() }}
              <span
                v-b-tooltip.hover.v-light
                :title="data.item.order_date"
                class="font-size-15"
                ><i class="bx bx-info-circle"></i></span
            ></span>
            <span
              v-else-if="
                data.item.status_name == 'Collected' &&
                data.item.is_collected == '1'
              "
              >{{ moment(data.item.order_date).fromNow() }}
              <span
                v-b-tooltip.hover.v-light
                :title="data.item.order_date"
                class="font-size-15"
                ><i class="bx bx-info-circle"></i></span
            ></span>
            <span v-else-if="data.item.status_name == 'OnTheWay'"
              >{{ moment(data.item.order_date).fromNow() }}
              <span
                v-b-tooltip.hover.v-light
                :title="data.item.order_date"
                class="font-size-15"
                ><i class="bx bx-info-circle"></i></span
            ></span>
            <span
              v-else-if="
                data.item.status_name == 'Delivered' &&
                data.item.is_delivered == '1'
              "
              >{{ moment(data.item.order_date).fromNow() }}
              <span
                v-b-tooltip.hover.v-light
                :title="data.item.order_date"
                class="font-size-15"
                ><i class="bx bx-info-circle"></i></span
            ></span>
            <span v-else-if="data.item.status_name == 'Cancelled'"
              >{{ moment(data.item.order_date).fromNow() }}
              <span
                v-b-tooltip.hover.v-light
                :title="data.item.order_date"
                class="font-size-15"
                ><i class="bx bx-info-circle"></i></span
            ></span>
            <span v-else
              >{{ moment(data.value).fromNow() }}
              <span
                v-b-tooltip.hover.v-light
                :title="data.value"
                class="font-size-15"
                ><i class="bx bx-info-circle"></i></span
            ></span>
          </template>
          <template #cell(total_amount)="data">
            <span v-html="currency"></span>
            {{ parseFloat(data.value || 0).toFixed(decimal) }}
          </template>

          <template #cell(payment_method)="data">
            <span
              class="badge badge-pill font-size-12"
              :class="{
                'badge-soft-success': data.value == 'Cash On Delivery',
                'badge-soft-warning': data.value != 'Cash On Delivery',
              }"
              v-if="
                data.item.order_status !== 'PaymentPending' &&
                data.item.order_status !== 'PaymentFailure' &&
                data.item.order_status !== 'AwaitForPayment'
              "
            >
              {{ data.value == "Cash On Delivery" ? "COD" : data.value }}
            </span>
            <span
              v-else
              class="badge badge-pill font-size-12"
              :class="{
                'badge-soft-warning':
                  data.item.order_status == 'PaymentPending',
                'badge-soft-danger': data.item.order_status == 'PaymentFailure',
                'badge-soft-info': data.item.order_status == 'AwaitForPayment',
              }"
            >
              {{
                data.item.order_status == "PaymentPending"
                  ? trans.get("__JSON__.Pending")
                  : data.item.order_status == "PaymentFailure"
                  ? trans.get("__JSON__.Failed")
                  : trans.get("__JSON__.Awaiting")
              }}
            </span>
          </template>
        </b-table>
      </div>
    </div>

    <!-- <OrderShow
      v-if="showModal"
      :order-id="orderId"
      @hidden="showModal = false"
    /> -->
    <!-- View Detail Main End -->
  </div>
</template>
<style>
</style> 